export function parseUrlParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    errorId: params.get('error_id') || '',
    traceId: params.get('trace_id') || '',
    timeRange: params.get('time_range') || '24h',
  };
}

export function pushUrlParams({ errorId, traceId, timeRange }) {
  const params = new URLSearchParams();
  if (errorId) params.set('error_id', errorId);
  if (traceId) params.set('trace_id', traceId);
  if (timeRange && timeRange !== '24h') params.set('time_range', timeRange);

  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.pushState({}, '', newUrl);
}
